/*
 *
 * Coupon reducer
 *
 */
import { createSlice } from '@reduxjs/toolkit';

import {
  createCouponAct,
  deleteCouponAct,
  getCouponsAct,
  resetGetCoupons,
  updateCouponAct,
} from './actions';

import couponEntityAdapter from './coupon-entity-adapter';

export const initialState = couponEntityAdapter.getInitialState({
  loadingState: 0,
  totalPages: 0,
  count: 0,
  createState: 0,
  updateState: 0,
  deleteState: 0,
});

/* eslint-disable default-case, no-param-reassign */
const couponSlice = createSlice({
  name: 'Coupon',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(getCouponsAct, (state, { payload }) => {
        const { loadingState, data, params } = payload;
        switch (loadingState) {
          case 1:
            state.loadingState = 1;
            if (params && params?.page === 1) {
              couponEntityAdapter.removeAll(state);
            }
            break;
          case 2:
            state.loadingState = 2;
            couponEntityAdapter.upsertMany(state, data.rows);
            state.totalPages = data.totalPages;
            state.count = data.count;
            break;
          case 3:
            state.loadingState = 3;
            break;
        }
      })
      .addCase(createCouponAct, (state, { payload }) => {
        const { loadingState, data } = payload;
        switch (loadingState) {
          case 2:
            state.createState = 2;
            couponEntityAdapter.addOne(state, data);
            state.totalPages = data.totalPages;
            state.count = data.count;
            break;
          default:
            state.createState = loadingState;
            break;
        }
      })
      .addCase(updateCouponAct, (state, { payload }) => {
        const { id, data, loadingState } = payload;
        switch (loadingState) {
          case 2:
            state.updateState = 2;
            if (id && state.entities[id]) {
              couponEntityAdapter.updateOne(state, {
                id,
                changes: {
                  name: data.name,
                  updatedAt: data.updateAt,
                },
              });
            }
            break;
          default:
            state.updateState = loadingState;
            break;
        }
      })
      .addCase(deleteCouponAct, (state, { payload }) => {
        const { id, loadingState } = payload;
        switch (loadingState) {
          case 2:
            state.deleteState = 2;
            couponEntityAdapter.removeOne(state, id);
            state.count -= 1;
            break;
          default:
            state.deleteState = loadingState;
            break;
        }
      })
      .addCase(resetGetCoupons, () => initialState);
  },
});

export default couponSlice.reducer;
